<aside class="sidebar" [class.collapsed]="!isOpen">
  <div class="sidebar-content">
    <div class="sidebar-header">
      <button class="menu-toggle" (click)="onToggleSidebar()">
        <svg class="hamburger-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 12H21" stroke="#111827" stroke-width="2" stroke-linecap="round"/>
          <path d="M3 6H21" stroke="#111827" stroke-width="2" stroke-linecap="round"/>
          <path d="M3 18H21" stroke="#111827" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
      <div class="logo-container" *ngIf="isOpen">
        <div class="logo-shape">
          <img src="assets/public/Aeroplast Logo.svg" alt="Aero Plast Logo" class="logo-image">
        </div>
        <!-- <div class="logo-text-container">
          <h2 class="logo-text">Aero Plast</h2>
          <p class="logo-subtitle">Since 1978</p>
        </div> -->
      </div>
    </div>
    <nav class="sidebar-nav">
      <div *ngFor="let item of menuItems" class="nav-item-wrapper">
        <!-- Products with dropdown -->
        <div *ngIf="item.hasSubmenu" class="nav-item-dropdown">
          <div 
            class="nav-item nav-item-parent" 
            [class.active]="isProductDropdownOpen || isSubItemActive(item)"
            (click)="toggleProductDropdown()">
            <span class="nav-icon">
              <!-- Products Icon -->
              <img *ngIf="item.icon === 'products'" src="assets/public/Products.png" alt="Products" class="nav-icon-img">
            </span>
            <span class="nav-label">{{ item.label }}</span>
            <svg class="dropdown-arrow" [class.open]="isProductDropdownOpen" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 6L8 10L12 6" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="submenu" [class.open]="isProductDropdownOpen">
            <a 
              *ngFor="let subItem of item.subItems" 
              [routerLink]="subItem.route" 
              routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: subItem.route === '/product'}"
              class="submenu-item">
              {{ subItem.label }}
            </a>
          </div>
        </div>
        <!-- Regular menu items without dropdown -->
        <a 
          *ngIf="!item.hasSubmenu"
          [routerLink]="item.route" 
          routerLinkActive="active"
          [routerLinkActiveOptions]="item.route === '/quote' ? {exact: false} : (item.route === '/leads' ? {exact: false} : {exact: false})"
          class="nav-item">
          <span class="nav-icon">
            <!-- Leads Icon -->
            <img *ngIf="item.icon === 'leads'" src="assets/public/Leads.png" alt="Leads" class="nav-icon-img" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';">
            <svg *ngIf="item.icon === 'leads'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: none;">
              <circle cx="10" cy="10" r="8" stroke="#1e3a8a" stroke-width="1.5"/>
              <path d="M10 6V10L13 13" stroke="#1e3a8a" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <!-- Quotes Icon -->
            <img *ngIf="item.icon === 'quotes'" src="assets/public/Quotes.png" alt="Quotes" class="nav-icon-img">
            <!-- Products Icon -->
            <img *ngIf="item.icon === 'products' && !item.hasSubmenu" src="assets/public/Products.png" alt="Products" class="nav-icon-img">
            <!-- Suppliers Icon -->
            <img *ngIf="item.icon === 'suppliers'" src="assets/public/Suppliers.png" alt="Suppliers" class="nav-icon-img">
            <!-- Team Icon -->
            <img *ngIf="item.icon === 'team'" src="assets/public/Team.png" alt="Team" class="nav-icon-img">
          </span>
          <span class="nav-label">{{ item.label }}</span>
        </a>
      </div>
    </nav>
  </div>
</aside>

